import { createHOC } from 'vue-hoc';

import withUser from '~lib/common/hoc/withUser';
import fecthOrgData from '~lib/common/utils/fetchOrgData';

import CasesDataView from '../components/CasesDataView.vue';

const options = {
  name: 'CasesDataContainer',
  data() {
    return {
      state: {
        orgData: {
          users: [],
          groups: [],
        },
      },
    };
  },
  created() {
    fecthOrgData(this.user)
      .then(orgData => {
        this.state.orgData = orgData;
      })
      .catch(error => {
        console.log(error);
      });
  },
};

const renderWith = {
  props: {
    orgData() {
      return this.state.orgData;
    },
  },
};

const CasesDataContainer = createHOC(CasesDataView, options, renderWith);
export default withUser()(CasesDataContainer);
